<template>
    <ul
        v-if="!expanded"
        class="collapse absolute flex w-32 flex-col rounded-[4px] border border-gray-800 bg-white text-gray-700 drop-shadow-[0_2px_4px_rgba(19,24,33,0.05)] group-hover:visible"
    >
        <li class="h-10 border-b border-gray-200 py-3 pl-2.5">
            <InertiaLink
                href="/players/me/rounds"
                class="flex h-4 transition-colors duration-500 ease-in-out hover:text-primary-500"
            >
                Home
            </InertiaLink>
        </li>
        <li class="h-10 border-b border-gray-200 py-3 pl-2.5">
            <!-- These needs to use <a> instead of InertiaLink to avoid CORS issues in some edge cases -->
            <a
                href="/players/me/clubs"
                class="flex h-4 transition-colors duration-500 ease-in-out hover:text-primary-500"
            >
                My Clubs
            </a>
        </li>
        <li class="h-10 border-b border-gray-200 py-3 pl-2.5">
            <a
                href="/account/info"
                class="flex h-4 transition-colors duration-500 ease-in-out hover:text-primary-500"
            >
                Account Info
            </a>
        </li>
        <li class="h-10 border-b border-gray-200 py-3 pl-2.5">
            <a
                href="/account/settings"
                class="flex h-4 transition-colors duration-500 ease-in-out hover:text-primary-500"
            >
                Settings
            </a>
        </li>
        <li class="h-10 border-b border-gray-200 py-3 pl-2.5">
            <a
                href="/account/subscription"
                class="flex h-4 transition-colors duration-500 ease-in-out hover:text-primary-500"
            >
                Subscription
            </a>
        </li>
        <li class="h-10 py-3 pl-2.5">
            <a
                :href="$page.props.logoutRoute"
                class="flex h-4 text-danger-500 transition-colors duration-500 ease-in-out hover:text-primary-500"
            >
                Log Out
            </a>
        </li>
    </ul>
    <ul
        v-else
        class="rounded border border-gray-200 bg-gray-600 font-bold"
    >
        <li>
            <InertiaLink
                href="/players/me/rounds"
                class="relative flex justify-center border-b border-b-gray-500 py-3 px-[18px] align-middle text-lg transition-colors duration-500 ease-in-out hover:text-primary-500"
            >
                Home
            </InertiaLink>
        </li>
        <li>
            <a
                href="/players/me/clubs"
                class="relative flex justify-center border-b border-b-gray-500 py-3 px-[18px] align-middle text-lg transition-colors duration-500 ease-in-out hover:text-primary-500"
            >
                My Clubs
            </a>
        </li>
        <li>
            <a
                href="/account/info"
                class="relative flex justify-center border-b border-b-gray-500 py-3 px-[18px] align-middle text-lg transition-colors duration-500 ease-in-out hover:text-primary-500"
            >
                Account Info
            </a>
        </li>
        <li>
            <a
                href="/account/settings"
                class="relative flex justify-center border-b border-b-gray-500 py-3 px-[18px] align-middle text-lg transition-colors duration-500 ease-in-out hover:text-primary-500"
            >
                Settings
            </a>
        </li>
        <li>
            <a
                href="/account/subscription"
                class="relative flex justify-center border-b border-b-gray-500 py-3 px-[18px] align-middle text-lg transition-colors duration-500 ease-in-out hover:text-primary-500"
                :headers="{ v: 2 }"
            >
                Subscription
            </a>
        </li>
        <li>
            <a
                :href="$page.props.logoutRoute"
                class="relative flex justify-center py-3 px-[18px] align-middle text-lg text-danger-500 transition-colors duration-500 ease-in-out hover:text-primary-500"
            >
                Log Out
            </a>
        </li>
    </ul>
</template>

<script setup></script>

<script>
export default {
    components: {},
    props: {
        expanded: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style scoped></style>
